import { render, staticRenderFns } from "./ReviewListTable.vue?vue&type=template&id=beae21a6&scoped=true"
import script from "./ReviewListTable.vue?vue&type=script&lang=js"
export * from "./ReviewListTable.vue?vue&type=script&lang=js"
import style0 from "./ReviewListTable.vue?vue&type=style&index=0&id=beae21a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beae21a6",
  null
  
)

export default component.exports